import { render } from "./Divipol.vue?vue&type=template&id=2541d70b&scoped=true"
import script from "./Divipol.vue?vue&type=script&lang=js"
export * from "./Divipol.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "../filtros.css?vue&type=style&index=1&id=2541d70b&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2541d70b"]])

export default __exports__